import { Link } from "react-router-dom";
import { adminProcApi } from "../../api";
import { ProcError, ProcLoading, ProcPagination } from "../../components/ProcurementLayout";
import { ProcStatusBadge } from "../../components/ProcStatusBadge";
import { useAsyncData, usePageState } from "../../hooks";

export default function FeedbackListPage() {
  const { page, size, setPage, state } = usePageState();

  const { data, loading, error } = useAsyncData(
    () => adminProcApi.listFeedback({ page: state.page, size: state.size }),
    [state.page, state.size],
  );

  return (
    <div className="space-y-5">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Department User Feedback</h1>
        </div>
        <Link to="/procurement/admin/feedback/new" className="rounded-xl bg-emerald-700 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-800">
          New Feedback
        </Link>
      </div>

      {loading && <ProcLoading />}
      {error && <ProcError message={error} />}

      {!loading && !error && data && (
        <>
          <div className="rounded-2xl border bg-white shadow-sm overflow-x-auto">
            <table className="w-full text-left text-sm">
              <thead className="bg-slate-50 text-xs uppercase text-slate-500">
                <tr>
                  <th className="px-4 py-3">Serial No</th>
                  <th className="px-4 py-3">Department</th>
                  <th className="px-4 py-3">Supplier</th>
                  <th className="px-4 py-3">Item / Service</th>
                  <th className="px-4 py-3">Quality</th>
                  <th className="px-4 py-3">Overall</th>
                  <th className="px-4 py-3">Date</th>
                  <th className="px-4 py-3 text-right">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {data.content.length === 0 && (
                  <tr><td colSpan={8} className="px-4 py-8 text-center text-slate-400">No feedback found.</td></tr>
                )}
                {data.content.map((r) => (
                  <tr key={r.id} className="hover:bg-slate-50">
                    <td className="px-4 py-3 font-mono font-semibold text-slate-900">{r.serialNo}</td>
                    <td className="px-4 py-3 text-slate-700">{r.departmentName || String(r.departmentId)}</td>
                    <td className="px-4 py-3 text-slate-600">{r.supplierName}</td>
                    <td className="px-4 py-3 text-slate-600 max-w-xs truncate">{r.itemService}</td>
                    <td className="px-4 py-3"><ProcStatusBadge value={r.qualityRating} /></td>
                    <td className="px-4 py-3"><ProcStatusBadge value={r.overallSatisfaction} /></td>
                    <td className="px-4 py-3 text-slate-500">{r.formDate ? new Date(r.formDate).toLocaleDateString() : "—"}</td>
                    <td className="px-4 py-3 text-right">
                      <Link to={`/procurement/admin/feedback/${r.id}`} className="font-semibold text-emerald-700 hover:underline">View</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <ProcPagination
            page={data.number}
            totalPages={data.totalPages}
            totalElements={data.totalElements}
            onPage={setPage}
          />
        </>
      )}
    </div>
  );
}
